import {
  AtLeastOnePermission,
  missingPermissions
} from "features/access-management";
import { TenantPermission, useTenantPermissions } from "features/tenant";

export const useRequestUserTenantPermissions = (
  requestedPermissions: AtLeastOnePermission<TenantPermission>
) => {
  const { data: permissionsData, ...queryResult } = useTenantPermissions();
  const myPermissions = permissionsData?.tenant.access.me?.permissions || [];
  const myMissingPermissions = missingPermissions(
    requestedPermissions,
    myPermissions
  );
  return {
    ...queryResult,
    ...myMissingPermissions
  };
};
